'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormGroupBase = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding: 13px 0px;\n  > label {\n    display: inline-block;\n    margin-bottom:7px;\n    margin-left: 2px;\n  }\n  > button {\n    display: block;\n    width: 100%;\n  }\n'], ['\n  padding: 13px 0px;\n  > label {\n    display: inline-block;\n    margin-bottom:7px;\n    margin-left: 2px;\n  }\n  > button {\n    display: block;\n    width: 100%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

var _label = require('@hixme-ui/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormGroupBase = exports.FormGroupBase = _styledComponents2.default.div(_templateObject);
var FormGroup = function FormGroup(_ref) {
  var children = _ref.children,
      label = _ref.label,
      error = _ref.error;
  return _react2.default.createElement(
    FormGroupBase,
    null,
    label && _react2.default.createElement(
      _label2.default,
      null,
      label
    ),
    children,
    error && _react2.default.createElement(
      _text2.default,
      { error: true },
      error
    )
  );
};

FormGroup.propTypes = {
  children: _propTypes2.default.node.isRequired,
  label: _propTypes2.default.string,
  error: _propTypes2.default.string
};

FormGroup.defaultProps = {
  label: null,
  error: null
};

FormGroup.displayName = 'hui:FormGroup';
FormGroup.huiName = 'FormGroup';

exports.default = FormGroup;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../form-group/lib/index.js
// module id = 158
// module chunks = 0